import styled from 'styled-components';

import HelpQuestion from '@/components/atom/icon/search/HelpQuestion';

const EmptyHospital = () => {
  return (
    <Wrapper>
      <EmptyResultWrapper>
        <HelpQuestion />
        <EmptyResultTitle>찾으시는 병원이 없어요</EmptyResultTitle>
        <EmptyResultOffer>
          필터를 확인하고, 위치를 변경해서
          <br />
          다시 검색해주세요.
        </EmptyResultOffer>
      </EmptyResultWrapper>
    </Wrapper>
  );
};

export default EmptyHospital;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 80px;
`;

const EmptyResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
`;

const EmptyResultTitle = styled.h3`
  ${({ theme }) => theme.typography.UI20SB};
  color: ${({ theme }) => theme.color.gray700};
  margin: 16px 0;
`;

const EmptyResultOffer = styled.p`
  ${({ theme }) => theme.typography.UI15R};
  color: ${({ theme }) => theme.color.gray400};
`;
